export default __webpack_public_path__ + "images/0003ae263356f8b2b8ac521ef59f9cb6-Eventbrite_Holiday_HomepageB_659x494.webp";